import Core from '_abstracts/core'
import ViewEvents from './elements-list-view'

Core.Tasks.add(['lazyloading'], () => {
    new ViewEvents()
})
